import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import type { AbstractStepProps } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { ButtonLegacy } from "@/shared/ui";
import { formatText } from "@/shared/ui/format";

export interface StepFields {
	loanGoal: string;
	married: boolean;
	numberOfChildren: number;
	numberOfChildrenCommitment: number;
	taxDept: boolean;
	socialInsuranceSinceId: number;
}

interface Props extends AbstractStepProps {
	csokAmount: number;
	numberOfChildren: number;
}

export class ResultSuitable extends AbstractStep<StepFields, Props> {
	protected renderContent(): ReactNode {
		const { csokAmount, numberOfChildren } = this.props;

		return (
			<>
				<Card.Header className="bg-success text-white text-center">
					<Card.Title className="pb-2">Jó hírünk van!</Card.Title>
					<Card.Subtitle>A megadott adatok alapján jogosult vagy a támogatásra.</Card.Subtitle>
				</Card.Header>
				<Card.Body className="d-flex flex-column">
					<div className="h3 my-auto text-success text-center">
						Az általad felvehető állami támogatás összege:
						<br />
						<mark className="d-inline-block mt-2 bg-success text-white">
							{formatText(csokAmount, "ft")}
						</mark>
					</div>
					{numberOfChildren === 1 && (
						<div className="extra-loan-info">
							A fenti támogatást <strong>kiegészítheted kedvező kamatozású lakáshitellel</strong> is.
						</div>
					)}
					{numberOfChildren === 2 && (
						<div className="extra-loan-info">
							A fenti támogatást <strong>kiegészítheted akár 10 millió Ft fix 3%-os CSOK hitellel</strong>{" "}
							is.
						</div>
					)}
					{numberOfChildren > 2 && (
						<div className="extra-loan-info">
							A fenti támogatást <strong>kiegészítheted akár 15 millió Ft fix 3%-os CSOK hitellel</strong>{" "}
							is.
						</div>
					)}
					<div className="mt-2">Kérjük válassz, melyik megoldás érdekel!</div>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy
						variant="secondary"
						block
						className="mb-2"
						onClick={() => this.onStep("lead-form-csok", false)}
					>
						Csak a CSOK érdekel
					</ButtonLegacy>
					<ButtonLegacy block onClick={() => this.onStep("step-4", false)}>
						CSOK + Lakáshitel érdekel
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "ResultSuitable";
	}
}
